"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
require("./style.css");
const Button = props => {
  const newProps = {
    ...props,
    onClick: e => props?.onClick(e),
    style: Object.assign({}, props.style)
  };
  const {
    buttontext,
    icon,
    className
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Button, (0, _extends2.default)({}, newProps, {
    className: `ixn-button ${className}`
  }), icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "ixn-button__icon"
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: "ixn-button__text"
  }, buttontext));
};
exports.Button = Button;
Button.defaultProps = {
  buttontext: "button",
  onClick: () => {},
  style: {},
  className: ""
};
Button.propTypes = {
  /** Specifies the click event to provide a call to action. */
  onClick: _propTypes.default.func,
  /** Specifies the type of button. By default it is 'secondary' */
  style: _propTypes.default.object,
  /** Specifies the button text. */
  buttontext: _propTypes.default.string.isRequired,
  /** Specifies icon to be displayed on button. It can be `<Icon />` component OR SVG. */
  icon: _propTypes.default.node,
  /** Disable the button. */
  disabled: _propTypes.default.bool
};